
import { Component, Vue, Prop } from 'vue-property-decorator';
import LoginTnc from './tnc/LoginTnc.vue';
import LoanContainer from './LoanContainer.vue';

@Component({
  components: {
    LoginTnc,
    LoanContainer,
  },
})
export default class LoginScreen extends Vue {
  @Prop() isMicroappsEnabled: any;
  @Prop() isGoogleSigninEnabled: any;

  private googleSignIn() {
    this.$emit('google-sign-in');
  }

  private openPhoneNumberScreen() {
    this.$emit('open-phone-number-screen');
  }
}
